module.exports = __webpack_public_path__ + "img/ic_filled_spin.e087ba4e.svg";